export const routes = {
  login: '/',
  dashboard: '/inicio',
  clients: '/clientes',
  clientsList: '/clientes/list',
  clientDetail: '/clientes/:cuit',
  risksAnalysis: '/analisisderiesgo',
  committee: '/comite',
  instrumentation: '/instrumentacion',
  finishedFolders: '/carpetas-finalizadas',
  dashboardComercial:'/dashboard',
  confirmation: '/confirmacion',
  forgotPassword: '/forgot-password',
  resetPassword: '/password-recovery/:token',
  users:'/usuarios',
  guarantees: '/avales',
  guaranteeDetail: '/avales/:cuit',
  groupedProductLineDetail: '/avales/:cuit/agrupado/:productLineCode/:currencyId',
  productLineDetail: '/avales/:cuit/linea/:id',
  loanDetail: '/avales/:cuit/linea/:lineId/prestamo/:id',
  checkDetail: '/avales/:cuit/linea/:lineId/cheque/:id',
  promissoryNoteDetail: '/avales/:cuit/linea/:lineId/pagare/:id',
  commercialEndorsementDetail: '/avales/:cuit/linea/:lineId/aval-comercial/:id',
  annexes: '/anexos',
  casfogHistory: '/anexos/historial',
  monetization: '/monetizacion',
  loanInstallmentSimulator: '/monetizacion/simulador-cuotas',
  processingHistory: '/monetizacion/historial-procesos',
  newMonetization: '/monetizacion/new',
  newSyndicatedMonetization: '/monetizacion/sindicados/new',
  newRequestLoad: '/monetizacion/nueva-solicitud/cargar',
  editMonetization: '/monetizacion/edit/:id',
  overdue: '/vencimientos',
  reportes: '/reportes',
  fundsAndProtectors: '/protectores',
  protectorDetail: '/protectores/:id',
  protectorEdit: '/protectores/:id/edit',
  protectorNew: '/protectores/new',
  protectorContributionNew: '/protectores/:id/aportes/new',
  protectorContributionEdit: '/protectores/:id/aportes/:contributionId/edit',
  partners: '/configuracion/socios',
  shares: '/configuracion/acciones',
  settings: '/configuracion',
  rateTypes: '/configuracion/tasas',
  sgr: '/configuracion/sgr',
  funds: '/configuracion/fondos',
  assetsToIntegrate: '/configuracion/activos',
  quotations: '/configuracion/cotizaciones',
  quotationsDetail: '/configuracion/cotizaciones/:assetCode',
  regulacionSepyme: '/configuracion/regulacion-sepyme',
  commissions: '/configuracion/comisiones',
  referrers: '/configuracion/referidos',
};
